import { render, staticRenderFns } from "./job-form-specs.vue?vue&type=template&id=dafb216c"
import script from "./job-form-specs.vue?vue&type=script&lang=js"
export * from "./job-form-specs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports